import {
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  Renderer2,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Platform } from '@ionic/angular';
import { AlertService } from './alert.service';

@Component({
  selector: 'fun-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('componentPlaceholder', { read: ViewContainerRef, static: true }) componentPlaceholder: ViewContainerRef;

  public ref: ComponentRef<AlertComponent>;
  childComponentRef$: Observable<ComponentRef<any>>;
  private close$: ReplaySubject<any>;
  type: string;
  title: string;
  status: string;
  enableCloseOut = false;
  closeOut = 'true';

  cross = false;

  constructor(
    private renderer: Renderer2,
    private chdRef: ChangeDetectorRef,
    private modalService: AlertService,
    private platform: Platform
  ) {
    this.close$ = new ReplaySubject();
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'pop');
  }

  ngAfterViewInit() {
    if (this.platform.is('android')) {
      this.platform.backButton.subscribe(() => {
        this.modalService.removeModal();
      });
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'pop');
  }

  onClose(): Observable<any> {
    return this.close$.asObservable();
  }

  setTitle(title: string): void {
    this.title = title;
    this.chdRef.detectChanges();
  }

  setStatus(status: string): void {
    this.status = status;
    this.chdRef.detectChanges();
  }

  close(externalClose: boolean = false) {
    this.modalService.removeModal();
  }

  getChildComponent<T>(): Observable<T> {
    return this.childComponentRef$.pipe(map((component: ComponentRef<T>) => component.instance));
  }

  public activeCross() {
    this.cross = true;
    this.chdRef.detectChanges();
  }

}
